import { rebind, merge } from "../utils";

import { change } from "../calculator";

import baseIndicator from "./baseIndicator";

const ALGORITHM_TYPE = "Change";

export default function () {
  const base = baseIndicator().type(ALGORITHM_TYPE);

  const underlyingAlgorithm = change();

  const mergedAlgorithm = merge()
    .algorithm(underlyingAlgorithm)
    .merge((datum, indicator) => {
      datum.change = indicator;
    });

  const indicator = function (data, options = { merge: true }) {
    let result;
    if (options.merge) {
      result = mergedAlgorithm(data);
    } else {
      result = underlyingAlgorithm(data);
    }

    return result;
  };
  rebind(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
  rebind(indicator, underlyingAlgorithm, "undefinedLength");
  rebind(indicator, underlyingAlgorithm, "options");
  rebind(indicator, mergedAlgorithm, "merge", "skipUndefined");

  return indicator;
}
